// src/components/DescriptionFrame.jsx
import React from "react";

/**
 * DescriptionFrame
 * ──────────────────────────────────────────────────────────────────────
 * Props:
 *   - object: the currentObject containing fields like `.name, .countries, .year, .description, .material, .purpose, .size, .currentLocation`
 *   - expanded: boolean (true ⇒ bottom‐sheet is expanded; false ⇒ only peek)
 *   - setExpanded: function to toggle expanded state
 *
 * Renders a little "grab‐handle" at top. Clicking anywhere toggles expanded vs peek.
 */
export default function DescriptionFrame({ object, expanded, setExpanded }) {
  if (!object) return null;

  return (
    <div
      className={`description-frame ${expanded ? "expanded" : ""}`}
      onClick={() => setExpanded((prev) => !prev)}
      style={{ maxHeight: expanded ? "80vh" : "50px", overflow: expanded ? "auto" : "hidden" }}
    >
      {/* The little handle bar at the top */}
      <div className="frame-handle" />

      {/* Show "More Information" only when not expanded */}
      {!expanded && <div className="more-info-label">More Information</div>}

      {/* The content area only becomes visible when 'expanded' */}
      <div className={`frame-content ${expanded ? "visible" : ""}`}>
        <div className="desc‐lines">
          <p>
            <strong>Name:</strong> {object.name}
          </p>
          <p>
            <strong>Country of Origin:</strong> {object.countries.join(", ")}
          </p>
          <p>
            <strong>Date:</strong>{" "}
            {object.year > 0
              ? `${object.year} AD`
              : `${Math.abs(object.year)} BC`}
          </p>
          {object.material && (
            <p>
              <strong>Material:</strong> {object.material}
            </p>
          )}
          {object.purpose && (
            <p>
              <strong>Purpose:</strong> {object.purpose}
            </p>
          )}
          {object.size && (
            <p>
              <strong>Size:</strong> {object.size}
            </p>
          )}
          {object.currentLocation && (
            <p>
              <strong>Current Location:</strong> {object.currentLocation}
            </p>
          )}
          <p style={{ marginTop: "12px" }}>
            <strong>Description:</strong>
          </p>
          <p>{object.description}</p>
        </div>
      </div>
    </div>
  );
}
